module.exports = __webpack_public_path__ + "static/img/b3.cbe658e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/b3.jpg
// module id = 73ot
// module chunks = 0